import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { queensConfig } from "./data";

export default function QueensPage() {
  return <CityPageTemplate config={queensConfig} />;
}